import { render, staticRenderFns } from "./ForeignKeyTable.vue?vue&type=template&id=50231098&scoped=true&"
import script from "./ForeignKeyTable.vue?vue&type=script&lang=js&"
export * from "./ForeignKeyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50231098",
  null
  
)

export default component.exports